import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.5 4.5h11M4.5 8h7M6.5 11.5h3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
